var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29.999,
    viewBox: "0 0 30 29.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "clock-Regular_1_",
    d: "M316.25,1228.25a15,15,0,1,0,15,15A15.017,15.017,0,0,0,316.25,1228.25Zm0,27.692a12.692,12.692,0,1,1,12.692-12.693A12.707,12.707,0,0,1,316.25,1255.942Zm7.308-12.693a1.154,1.154,0,0,1-1.154,1.154H316.25a1.154,1.154,0,0,1-1.154-1.154v-7.692a1.154,1.154,0,0,1,2.308,0v6.539h5A1.155,1.155,0,0,1,323.558,1243.249Z",
    transform: "translate(-301.25 -1228.25)",
    fill: "#e23744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.508b8ccf8dedc39fa6b6cdb94c99cc9f.svg";
export { ForwardRef as ReactComponent };